import { render, staticRenderFns } from "./fullpagehorsesmouth.vue?vue&type=template&id=3b96275e&scoped=true"
import script from "./fullpagehorsesmouth.vue?vue&type=script&lang=js"
export * from "./fullpagehorsesmouth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b96275e",
  null
  
)

export default component.exports